import { Component } from "@angular/core";

@Component({
    selector: "codman-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    standalone: false,
})
export class AppComponent {
    title = "indicators";
}
